module.exports = {"210904001":"红树街道","210904003":"高德街道","210904004":"孙家湾街道","210904101":"水泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210904.json
// module id = 654
// module chunks = 0